import { FetchResult, gql } from '@apollo/client';
import { apolloMutation } from '../apollo';
import { GenerateBankConnectorTokenMutation } from '../gql/graphql';

export interface BankConnectionService {
  generateBankConnectorToken(orderId: String, language?: string): Promise<FetchResult<GenerateBankConnectorTokenMutation>>;
}

const bankConnectionService: BankConnectionService = {
  async generateBankConnectorToken(orderId: String, language?: string) {
    return apolloMutation(GENERATE_BANK_CONNECTOR_TOKEN, { input: { orderId: orderId, language: language } }) as Promise<
      FetchResult<GenerateBankConnectorTokenMutation>
    >;
  },
};

export const GENERATE_BANK_CONNECTOR_TOKEN = gql`
  mutation generateBankConnectorToken($input: GenerateBankConnectorTokenInput!) {
    generateBankConnectorToken(input: $input) {
      linkToken
      linkTokenExpiration
      generateBankConnectorTokenErrors {
        __typename
        ... on NotFound {
          message
        }
        ... on FatalError {
          message
        }
        ... on BadRequest {
          message
        }
      }
    }
  }
`;

export default bankConnectionService;
